const homepage = () => {
    if ($(".homepage").length) {
        // slideBanner();
        slideAdvertisement();
        slideCustomerRates();
        slideNews();
    }
}

const slideBanner = () => {
    $(".background-banner").slick({
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
        autoplay: false,
        speed: 300,
        autoplaySpeed: 2000,
    });
}

const slideNews = () => {
    $(".news-slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: $(".form-next-back").find(".btn-next"),
        prevArrow: $(".form-next-back").find(".btn-prev"),
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                },
            },
        ]
    });
}

const slideAdvertisement = () => {
    $(".advertisement-slider").slick({
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
        autoplay: false,
        speed: 300,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    vertical: false,
                    verticalSwiping: false,
                    centerMode: false,
                    arrows: false,
                }
            },
        ]
    });
}

const slideCustomerRates = () => {
    $(".customer-feedback").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: $(".form-next-back").find(".next"),
        prevArrow: $(".form-next-back").find(".prev"),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    vertical: false,
                    verticalSwiping: false,
                    centerMode: false,
                    arrows: false,
                }
            },
        ]
    });
}

module.exports = homepage
